import { navigationGroups } from '@/data/navigation'
import type { ViewId } from '@/types/navigation'
import { NavigationItem } from './NavigationItem'
import { SocStatusPanel } from './SocStatusPanel'
import styles from './Sidebar.module.css'

interface SidebarProps {
  activeView: ViewId
  onSelect: (id: ViewId) => void
  mobileOpen: boolean
  onCloseMobile: () => void
}

export function Sidebar({ activeView, onSelect, mobileOpen, onCloseMobile }: SidebarProps) {
  const handleSelect = (id: ViewId) => {
    onSelect(id)
    onCloseMobile()
  }

  return (
    <>
      {mobileOpen && <div className={styles.scrim} onClick={onCloseMobile} aria-hidden="true" />}
      <nav
        className={`${styles.root} ${mobileOpen ? styles.open : ''}`}
        aria-label="Navigare principală"
      >
        <div className={styles.groups}>
          {navigationGroups.map((group) => (
            <div key={group.id} className={styles.group}>
              <span className={styles.groupTitle}>{group.title}</span>
              <div className={styles.items}>
                {group.items.map((item) => (
                  <NavigationItem
                    key={item.id}
                    item={item}
                    active={activeView === item.id}
                    onSelect={handleSelect}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
        <SocStatusPanel />
      </nav>
    </>
  )
}
